import { ImpactType, TileSource, TileVariant } from '../';
import { PublicProjectSummary } from '../projects';
import { dateParser } from '../utils';

export type CarbonRemovalType = {
  _id: string;
  createdAt: string;
  impactType: ImpactType;
  invoiceId?: string;
  isPending?: boolean;
  isMocked?: boolean;
  name?: string;
  numberOfTonnes: number;
  projectId: number;
  projectTitle?: string;
  variant: TileVariant;
  source: TileSource;
  groupId?: number;
};

export class CarbonRemoval {
  _id: string;
  createdAt: Date;
  impactType: ImpactType;
  invoiceId?: string;
  isMocked?: boolean;
  isPending?: boolean;
  name?: string;
  numberOfTonnes: number;
  project?: PublicProjectSummary;
  projectId: number;
  projectTitle?: string;
  variant: TileVariant;
  source: TileSource;
  groupId?: number;

  constructor(removal: CarbonRemovalType, project?: PublicProjectSummary) {
    this._id = removal._id;
    this.createdAt = dateParser(removal.createdAt);
    this.impactType = ImpactType.CARBON_REMOVAL;
    this.invoiceId = removal.invoiceId;
    this.isMocked = removal.isMocked == true;
    this.isPending = removal.isPending == true;
    this.name = removal.name;
    this.numberOfTonnes = removal.numberOfTonnes;
    this.project = project;
    this.projectId = removal.projectId;
    this.projectTitle = removal.projectTitle;
    this.variant = removal.variant;
    this.source = removal.source;
    this.groupId = removal.groupId;
  }
}
